module.exports = __webpack_public_path__ + "static/img/P8.891ac691.png";